/**
 * Transport envelope shared by every REST endpoint.
 *
 * PROPOSED CONTRACT — the Architecture Agent must ratify (or replace) this
 * envelope in the "API contract" task before any endpoint is implemented.
 * The frontend and the backend both import these types, so a change here is a
 * breaking change for both sides and must be routed through the Manager.
 */
/** Machine-readable error codes. Never expose raw stack traces to clients. */
export const API_ERROR_CODES = [
    'BAD_REQUEST',
    'VALIDATION_FAILED',
    'UNAUTHENTICATED',
    'TOKEN_EXPIRED',
    'TOKEN_INVALID',
    /** A valid Microsoft identity with no Prisco account. No account is created. */
    'SSO_IDENTITY_NOT_PROVISIONED',
    /** Microsoft sign-in succeeded but the Prisco account is `INACTIVE`. */
    'ACCOUNT_INACTIVE',
    /** The Prisco account is bound to a different Microsoft identity. */
    'SSO_IDENTITY_CONFLICT',
    /** The bound Microsoft account now reports a different email. */
    'SSO_EMAIL_MISMATCH',
    'FORBIDDEN',
    'PROJECT_ACCESS_DENIED',
    'LAST_SUPER_ADMIN',
    'NOT_FOUND',
    'CONFLICT',
    'RATE_LIMITED',
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
];
//# sourceMappingURL=common.js.map